import { lazy } from 'react';
import { RouteType } from './models/route.model';

// TODO : Role based route managament
const MAVEN_URLS = [{
		path: '/new-link-policy',
		isPublic: true,
		component: checkAccess(lazy((): any => import('../modules/LinkPolicy/LinkPolicy'))),
	},
	{
		path: '/oop',
		isPublic: true,
		component: checkAccess(lazy((): any => import('../modules/eligibility/oop'))),
	},
	{
		path: '/sso-saml',
		isPublic: true,
		component: checkAccess(lazy((): any => import('../modules/sso/sso'))),
	},
	{
		path: '/kyc',
		isPublic: true,
		component: checkAccess(lazy((): any => import('../modules/kyc/Kyc'))),
	},
	{
		path: '/siProtect',
		isPublic: true,
		component: lazy(
			(): any => import('../modules/profile/SecureTransaction')),
	},
	{
		path: '/link-policy',
		isPublic: true,
		component: checkAccess(lazy((): any => import('../modules/LinkPolicy/LinkPolicy'))),
	},
	{
		path: '/new-home',
		isPublic: true,
		component: lazy(
			(): any => import('../modules/newHomeScreen/NewHomeScreenUI')),
	},
]
const RoutesConfig: RouteType = {
	publicRoutes: (process.env.NODE_ENV.includes('maven') ? MAVEN_URLS : []).concat([
		{
			path: '/logout',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/logout/LogOut'))),
		},
		{
			path: '/',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/node20/AuthLogin/Login'))),
		},
		{
			path: '/login',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/node20/AuthLogin/Login'))),
		},
		{
			path: '/forget-password',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/node20/AuthLogin/forget-password/reset-password'))),
		},
		{
			path: '/beneficiaries/:maid',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/home/beneficiarydetails'))),
		},
		{
			path: '/policies/:maid',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/home/policydetails'))),
		},
		{
			path: '/auth/:claimId',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/Login/Login'))),
		},
		{
			path: '/claimdetails',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/claim/Claim'))),
		},
		{
			path: '/claimdetails/:claimId',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/claim/Claim'))),
		},
		{
			path: '/claimEncrypt/:claimId',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/claim/claimEncrypt'))),
		},
		{
			path: '/claimList',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/claim/claimListFolder/ClaimList'))),
		},
		{
			path: '/resetPassword',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/resetPassword/ResetPassword'))),
		},
		{
			path: '/forgotPassword',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/forgotPassword/ForgotPassword'))),
		},
		{
			path: '/Hospitals',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/node20/pages/networkHospitals'))),
		},
		{
			path: '/home',
			isPublic: true,
			// component: checkAccess(lazy((): any => import('../modules/home/Home'))),
			component: checkAccess(lazy((): any => import('../modules/node20/pages/home/Index'))),
		},
		{
			path: '/policy/:policyNo',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/policy/Policy'))),
		},
		{
			path: '/intimationdetails/:intimationId',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/intimation/IntimationDetails'))),
		},
		{
			path: '/createIntimation',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/intimation/IntimationForm'))),
		},
		{
			path: '/help',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/help/Help'))),
		},
		{
			path: '/travel-benefits',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/travel-guidelines/TravelBenefits'))),
		},
		{
			path: '/enrollment',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/Enroll'))),
		},
		{
			path: '/claim-submission',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/ClaimSubmission'))),
		},
		{
			path: '/account',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/profile/Account'))),
		},

		{
			path: '/family-member-details',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/profile/FamilyMemberDetails'))),
		},
		{
			path: '/updateContact',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/profile/UpdateContactDetails'))),
		},
		{
			path: '/bankAccount',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/profile/bankAccount/bankAccDetails'))),
		},
		{
			path: '/reset-password',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/profile/resetPassword/resetPasswordMethods'))),
		},
		{
			path: '/reset-password/:encryptedToken',
			isPublic: true,
			component: lazy(
				(): any => import('../modules/resetPassword/ResetPasswordFromLink')),
		},
		{
			path: '/verify-otp/:tag',
			isPublic: true,
			component: checkAccess(lazy((): any => import('../modules/profile/resetPassword/verifyOtp'))),
		},
		{
			path: '/healthDocuments',
			isPublic: true,
			component: lazy(
				(): any => import('../modules/policy/healthDocuments')),
		},
		{
			path: '/logout-handler',
			isPublic: true,
			component: lazy(
				(): any => import('../modules/logout/logout-handler')),
		},
		{
			path: '/health-benefits',
			isPublic: true,
			component: checkAccess(lazy(
				(): any => import('../modules/healthBenefits/HealthBenefits'))
			),
		},
		{
			path: '/opd-wallet',
			isPublic: true,
			component: checkAccess(lazy(
				(): any => import('../modules/opd-wallet/OpdWallet'))
			),
		},
		{
			path: '/healthBenefits-list',
			isPublic: true,
			component: checkAccess(lazy(
				(): any => import('../modules/opd-wallet/HealthBenefitLists'))
			),
		},
		{
			path: '*',
			isPublic: false,
			component: checkAccess(lazy(
				(): any => import('../common/components/PageNotFoundComponent'))
			),
		},
	]),
	privateRoutes: [
		{
			path: '/',
			isPublic: false,
			isExact: true,
			subRoutes: [
				{
					path: 'logout',
					isPublic: false,
					isExact: false,
					component: (): any => 'Log out',
				},
				{
					path: 'profile',
					isPublic: false,
					isExact: false,
					component: (): any => 'Profile',
				},
				{
					path: 'claim',
					isPublic: false,
					isExact: false,
					component: (): any => 'Claim',
				},
				{
					path: '*',
					isPublic: false,
					component: (): any => 'no component found',
				},
			],
		},
	],
};
export default RoutesConfig;



function checkAccess(param) {
	let accessToken = localStorage.getItem('accessToken');
	let currentURLPathname = window.location.pathname;

	// if(!accessToken && currentURLPathname!=='/'){
	//   localStorage.setItem('requestedURLpathname',currentURLPathname);
	// }
	// if(accessToken && localStorage.getItem('requestedURLpathname')){
	//   localStorage.removeItem('requestedURLpathname')
	// }

	return param;
}